import React from "react";
import Box from "../Box";
import MrclText from "../marcel/MrclText";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import CommercialLayout from "../CommercialLayout";
import { useLocation } from "react-router";
const Text = styled(MrclText)`
  font-family: system-ui;
`;
const NotFoundPage = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const isLast =
    location.pathname === "/commercial/lastweek" ||
    location.pathname === "/commercial/lastmonth";

  const pageContent = (
    <Box>
      <Box display="flex" flexDirection="column" alignItems="center" py={3}>
        <Text size="l">{t("common.page_not_found")} ☹️</Text>
      </Box>
    </Box>
  );

  return isLast ? (
    <CommercialLayout>{pageContent}</CommercialLayout>
  ) : (
    pageContent
  );
};

export default NotFoundPage;
